<template>
  <v-icon
    :color="liked ? '#e50914' : iconColor"
    :size="size"
    style="cursor: pointer;"
    @click.stop="likedSongsStore.toggle(videoId)"
  >{{ liked ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
</template>

<script>
import { useLikedSongsStore } from '../stores/likedSongs';

export default {
  name: 'LikeButton',
  props: {
    videoId: { type: String, required: true },
    size: { type: [String, Number], default: 'default' },
    iconColor: { type: String, default: '#ffffff' },
  },
  setup() {
    const likedSongsStore = useLikedSongsStore();
    likedSongsStore.ensureLoaded();
    return { likedSongsStore };
  },
  computed: {
    liked() {
      return this.likedSongsStore.isLiked(this.videoId);
    },
  },
};
</script>
